module.exports = __webpack_public_path__ + "img/Wp_2068.6faa7703.png";